import { TypeDays, TypeEntity, TypeUser } from "../../../enums/enums";
import { IEntityDoc } from "../doc/IEntityDoc";
import { IFileParameterizationDoc } from "../doc/IFileParameterizationDoc";
import { IParamResponseTimeDoc } from "../doc/IParamResponseTimeDoc";
import firebase from "firebase";
import { EntityForm } from "../form/EntityFrom";

  
  export function setEntity(entity: EntityForm, uid: string): IEntityDoc {
    let datareturn: IEntityDoc = {
      id: entity.nit,
      createdAt: firebase.firestore.Timestamp.now(),
      address: entity.address,
      active: entity.active,
      idEntity: entity.nit,
      uid: uid,
      businessName: entity.businessName,
      daneCode: entity.daneCode,
      entityType: TypeEntity.PUBLIC,
      emailSender: entity.emailSender,
      emailMailjet: entity.emailMailjet,
      phone: entity.phone,
      sigepCode: entity.sigepCode,
      country: entity.country,
      department: entity.department,
      town: entity.town,
      admin: entity.id.toString(),
      nit: entity.nit.toString(),
    };
  
    return datareturn;
  }
  
  export function setParamResponseTime(): IParamResponseTimeDoc {
    let datareturn: IParamResponseTimeDoc = {
      RightToPetitionInterestDays: 1,
      RightToPetitionInterestTypeDays: TypeDays.CALENDAR,
      CitizenComplaintsDays: 1,
      CitizenComplaintsTypeDays: TypeDays.CALENDAR,
      PublicServantComplaintsDays: 1,
      PublicServantComplaintsTypeDays: TypeDays.CALENDAR,
      ClaimsDays: 1,
      ClaimsTypeDays: TypeDays.CALENDAR,
      ComplaintsDays: 1,
      ComplaintsTypeDays: TypeDays.CALENDAR,
      ApplicationDocumentsOrCopiesDays: 1,
      ApplicationDocumentsOrCopiesTypeDays: TypeDays.CALENDAR,
      ApplicationPublicInformationDays: 1,
      ApplicationPublicInformationTypeDays: TypeDays.CALENDAR,
      PetitionBetweenAuthoritiesDays: 1,
      PetitionBetweenAuthoritiesTypeDays: TypeDays.CALENDAR,
      ConsultationApplicationDays: 1,
      ConsultationApplicationTypeDays: TypeDays.CALENDAR,
      ConceptApplicationDays: 1,
      ConceptApplicationTypeDays: TypeDays.CALENDAR,
      CopyByCompetitionDays: 1,
      CopyByCompetitionTypeDays: TypeDays.CALENDAR,
      ApplicationDays: 1,
      ApplicationTypeDays: TypeDays.CALENDAR,
    };
  
    return datareturn;
  }
  
  export function setFileParameterization(): IFileParameterizationDoc {
    let datareturn: IFileParameterizationDoc = {
      createdAt: firebase.firestore.Timestamp.now(),
    };
  
    return datareturn;
  }
